import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-gtag";
import { EuiSpacer } from "@elastic/eui";
import NavButtons from "components/Outdoor_Cameras/IN-9820_QFHD/NavButtons";
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
export const _frontmatter = {
  "title": "IN-9820 4K (QFHD) Manuelle Objektivjustage",
  "path": "/Aussenkameras/IN-9820_QFHD/Objektivjustage/",
  "dateChanged": "2017-12-12",
  "author": "Mike Polinowski",
  "excerpt": "INSTAR IN-9820 4K (QFHD) Outdoor IP-Kamera Manuelle Objektivjustage",
  "image": "./P_SearchThumb_IN-9008HD_Lense_Adjust.png",
  "social": "/images/Search/P_SearchThumb_IN-9820QFHD_Lense_Adjust.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-IN-9008HD_white.webp",
  "chapter": "Outdoor Cameras"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title="IN-9820 4K (QFHD) Manuelle Objektivjustage" dateChanged="2017-12-12" author="Mike Polinowski" tag="INSTAR IP Camera" description="INSTAR IN-9820 4K (QFHD) Outdoor IP-Kamera Manuelle Objektivjustage" image="/images/Search/P_SearchThumb_IN-9420HD_Lense_Adjust.png" twitter="/images/Search/P_SearchThumb_IN-9420HD_Lense_Adjust.webp" location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN="/en/Outdoor_Cameras/IN-9820_QFHD/Lense_Adjustment/" locationFR="/fr/Outdoor_Cameras/IN-9820_QFHD/Lense_Adjustment/" crumbLabel="Lense" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h2 {...{
      "id": "in-9820-4k-qfhd-handbuch",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#in-9820-4k-qfhd-handbuch",
        "aria-label": "in 9820 4k qfhd handbuch permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`IN-9820 4K (QFHD) Handbuch`}</h2>
    <h3 {...{
      "id": "objektiv-einstellung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#objektiv-einstellung",
        "aria-label": "objektiv einstellung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Objektiv-Einstellung`}</h3>
    <p>{`Die IN-9820 4K (QFHD) ist mit einem Autofokus-Zoom-Objektiv ausgestattet und hat einen Zoombereich von 2,7mm bis 13.5mm. Somit ermöglicht dieses Objektiv einen diagonalen Bildausschnitt von 30 Grad bis 130 Grad. Durch einen fortschrittlichen Algorithmus kann das Objektiv automatisch die Schärfe so ausrichten, dass man ein gestochen scharfes Bild erhält.`}</p>
    <p>{`Bitte beachten Sie, dass der Autofokus ein paar Sekunden braucht, um sich zu fokussieren und ein scharfes Bild zu liefern. Während dieser Zeit pausiert die Pan/Tilt-Funktion. Sobald das Objektiv sich justiert hat, können Sie die Pan/Tilt-Funktion wieder ausführen.`}</p>
    <p>{`Nutzer sollten immer `}<strong parentName="p">{`VERMEIDEN`}</strong>{`, am Objektiv zu hantieren und `}<strong parentName="p">{`DÜRFEN NIEMALS`}</strong>{` versuchen, das Objektiv manuell zu justieren. Jede manuelle Justierung resultiert in einem permanenten Verlust des Zooms, was nicht rückgängig gemacht werden kann.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      